import { useMutation, useQueryClient } from '@tanstack/react-query';
import { dataSelector } from '@nextiva/global-store';
import { useSelector } from 'react-redux';
import { deleteEnablementInfo } from 'services';
import { useSnackbar } from 'hooks';
import { ENABLEMENT_INFO_KEY } from '../constants';

export function useDeleteEnablementInfo() {
  const globalStoreData = useSelector(dataSelector);
  const corpAcctNbr = globalStoreData.user?.profileDTO?.corpAcctNbr;
  const setSnackbar = useSnackbar();
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: () => deleteEnablementInfo(corpAcctNbr),
    onMutate: async () => {
      await queryClient.cancelQueries([ENABLEMENT_INFO_KEY]);
      const previousData = queryClient.getQueryData([ENABLEMENT_INFO_KEY]);
      queryClient.setQueryData([ENABLEMENT_INFO_KEY], (oldData) =>
        oldData ? null : oldData,
      );
      return { previousData };
    },
    onError: (_error, _, context) => {
      queryClient.setQueryData([ENABLEMENT_INFO_KEY], context.previousData);

      setSnackbar({
        message: 'Sorry, we were unable to delete.',
        severity: 'error',
      });
    },
  });
  return mutation;
}
